import React, { useMemo } from "react";
import { Input } from "../Form";
import { ButtonBlack, ButtonGrey, ButtonPrimary } from "../Button";
import { Select } from "../../ui";
import { connect } from "react-redux";
import { isAgencyAdmin, isCompanyAdmin } from "../../modules/permissions";
import { agencyHasFeature, token } from "../../modules/auth";
import PreferredProgrammeFilters from "../PreferredProgrammes/PreferredProgrammeFilters";
import { AGENCY_PERMISSIONS } from "../../constants";

let HotelGroupFilters = ({
  hotelGroupTypes,
  setHotelGroupType,
  hotelGroupType,
  searchTerm,
  setSearchTerm,
  resetFilters,
  triggerSearch,
  selectedAgency,
  setSelectedAgency,
  selectedCompany,
  setSelectedCompany,
  preferredPrograms = null,
  hideGroupType,
  agencyHasCorporatePermission,
  agencyCanHaveChildAgencies,
}) => {
  const getHotelGroupTypeOptions = useMemo(() => {
    let options = [];
    hotelGroupTypes &&
      hotelGroupTypes.length > 0 &&
      hotelGroupTypes.map(type => {
        if (type.code === "HBR" || type.code === "HGR") {
          options.push({
            text: type.name,
            value: type.id,
          });
        }
      });
    return options;
  }, [hotelGroupTypes]);

  return (
    <div>
      <div className="mb-3 md:flex md:flex-row md:justify-between uppercase md:items-center">
        <div className="flex w-full">
          {preferredPrograms ? null : (
          <div className="col">
            <Input
              input={{
                onChange: e => setSearchTerm(e.target.value),
                value: searchTerm,
                onKeyDown: e => {
                  if (e.key === "Enter") {
                    triggerSearch();
                  }
                },
              }}
              meta={{}}
              name="search"
              label="Filter by keyword"
              labelClassName="block uppercase font-heading text-xs mb-1"
              wrapperClassName="mb-0"
            />
          </div>)}
          {hideGroupType ? (
            <></>
          ) : (
            <div className="col">
              <Select
                name="groupType"
                label="Filter by Group Type"
                component={Select}
                options={getHotelGroupTypeOptions}
                wrapperClassName="mx-1"
                input={{
                  onChange: e => setHotelGroupType(e.target.value),
                  value: hotelGroupType,
                }}
                meta={{}}
              />
            </div>
          )}
          {preferredPrograms ? (
            <PreferredProgrammeFilters
              selectedAgency={selectedAgency}
              setSelectedAgency={setSelectedAgency}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
            />
          ) : null}
          {preferredPrograms &&  !agencyCanHaveChildAgencies && !agencyHasCorporatePermission  ? <></>
          :
            preferredPrograms ?
            <div className={'flex'}>
              <div >
                <ButtonGrey
                  classes="mt-4 mr-2  ml-auto"
                  onClick={resetFilters}
                  title="Reset filters"
                >
                  <i className="fal fa-redo"></i>
                </ButtonGrey>
              </div>
              <div >
                <ButtonPrimary
                  classes="mt-4 ml-auto"
                  onClick={triggerSearch}
                  title="Search"
                >
                  Apply Filter
                </ButtonPrimary>
              </div>
            </div> : null
          }
          {!preferredPrograms  ? <div className={'flex'}>
              <ButtonGrey
                classes="mt-4 mr-2 ml-auto"
                onClick={resetFilters}
                title="Reset filters"
              >
                <i className="fal fa-redo"></i>
              </ButtonGrey>
              <ButtonPrimary
                classes="mt-4 ml-auto"
                onClick={triggerSearch}
                title="Search"
              >
                Apply Filter
              </ButtonPrimary>
          </div> : null }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: props.hotelGroup,
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    agencyHasCorporatePermission: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_HAVE_CORPORATE_ACCOUNTS),
    agencyCanHaveChildAgencies: agencyHasFeature(state.auth, AGENCY_PERMISSIONS.CAN_ADD_CHILD_AGENCIES),
    token: token(state),
    ...state.countries,
  };
};

HotelGroupFilters = connect(mapStateToProps, {})(HotelGroupFilters);

export default HotelGroupFilters;
